<script>
import FormBlock from '@/components/FormBlock.vue';
import CarouselArrows from '@/components/ui/CarouselArrows.vue';
import UserDetailStatisticTileItem from '@/components/user/tiles/UserDetailStatisticTileItem.vue';

export default {
  name: 'UserDetailStatisticTile',
  components: { FormBlock, CarouselArrows, UserDetailStatisticTileItem },
  props: {
    user: Object,
    statistic: Object,
    label: String,
    isBorderShown: Boolean,
  },
  computed: {
    keys() {
      return Object.keys(this.statistic);
    },
  },
};
</script>

<template lang="pug">
FormBlock(mobile)
  .b-user-detail-statistic-tile
    ._header(:class="{ 'header-border': isBorderShown }")
      ._headliner {{ label }}
    slot(name="header" )
    ._tiles
      UserDetailStatisticTileItem(v-for="key in keys" :key="key" :label="statistic[key].label" :icon="statistic[key].icon" :value="statistic[key].value" :title="statistic[key].title")
</template>

<style scoped lang="scss">
.user-detail-statistic-tile {
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__headliner {
    color: rgb(30, 49, 71);
    font-family: Geometria, sans-serif;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0;
    text-align: left;
  }

  &__tiles {
    padding-top: 26px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 28px;
  }
}

.header-border {
  padding-bottom: 6px;
  border-bottom: 1px solid rgb(235, 239, 242);
}
</style>
